function scrollUp(value) {
  let top = 0;
  var selection = document.querySelector('.app-layout');
  var header = document.querySelector('.main-header');
  if (selection !== null && selection !== undefined) {
    top = selection.getBoundingClientRect().top + window.scrollY - header.clientHeight;
  }
  const position = value ? value : top;

  window.scrollTo({
    top: position,
    left: 0,
    behavior: 'smooth'
  });
}

export default scrollUp;